import { Button, ButtonProps, Stack, Typography } from '@mui/material';

interface Props {
  title?: string;
  description?: string;
  action?: ButtonProps;
  size?: 'small' | 'medium' | 'large';
}

const EmptyState = ({
  size = 'medium',
  title = 'Sin Contenido',
  description = 'Cuando agregues contenido se verá aquí',
  action,
}: Props) => {
  return (
    <Stack spacing={1} alignItems="center" justifyContent="center" flex={3}>
      <Stack textAlign="center" spacing={0}>
        <Typography variant="h2">{title}</Typography>
        <Typography variant="body2" sx={{ marginTop: 0 }}>
          {description}
        </Typography>
      </Stack>
      {action ? <Button {...action} fullWidth={false} size={size} /> : null}
    </Stack>
  );
};

export default EmptyState;
